export default {
  participatingResources: {
    searchFilters: {
    },
    landing: [],
    searchCriteria: {
      facet_filters: {},
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
    },
    searchResults: [],
    detail: {},
    datasets: [],
  },
  datasets: {
    searchCriteria: {
      search_text: '',
      filters: {
        primary_disease: [
        ],
        dataset_source_repo: [
        ],
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      sort: {
        name: 'Dataset',
        k: 'dataset_title_sort',
        v: 'asc',
      },
      viewType: 'card',
    },
    searchResults: [],
    searchSourceResults: 'all',
    resourcesList: [],
    details: {},
  },
  resources: {
    searchCriteria: {
      search_text: '',
      filters: {
        resource_research_area: [
        ],
        resource_tool_type: [
        ],
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      sort: {
        name: 'Resource',
        k: 'resource_title_sort',
        v: 'asc',
      },
      viewType: 'card',
    },
    searchResults: [],
    searchSourceResults: 'all',
    resourcesList: [],
    details: {},
  },
  application: {
    softwareVersion: '',
    siteDataUpdate: '',
    widgetUpdates: [],
    siteUpdates: [],
    pageInfo: {
      page: 1,
      pageSize: 10,
      total: 100,
    },
    glossaryTerms: {},
    glossaryLetters: {},
    glossaryDetails: {},
  },
};
